"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackMessage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _icons = require("@creditas/icons");

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  children: _propTypes.node.isRequired,
  variant: (0, _propTypes.oneOf)([_components.VARIANT_TYPES.success, _components.VARIANT_TYPES.danger, _components.VARIANT_TYPES.info, _components.VARIANT_TYPES.warning]).isRequired
} : {};

const IconSuccess = () => (0, _core.jsx)(_icons.Notification.CheckCircle, {
  color: _components.VARIANT_TYPES.success,
  fontSize: "large"
});

const IconWarning = () => (0, _core.jsx)(_icons.Alert.AlertTriangle, {
  color: _components.VARIANT_TYPES.warning,
  fontSize: "large"
});

const IconError = () => (0, _core.jsx)(_icons.Action.XCircle, {
  color: _components.VARIANT_TYPES.danger,
  fontSize: "large"
});

const IconInfo = () => (0, _core.jsx)(_icons.Alert.Info, {
  color: _components.VARIANT_TYPES.info,
  fontSize: "large"
});

const variantIcon = {
  [_components.VARIANT_TYPES.success]: IconSuccess,
  [_components.VARIANT_TYPES.warning]: IconWarning,
  [_components.VARIANT_TYPES.danger]: IconError,
  [_components.VARIANT_TYPES.info]: IconInfo
};
const RootContainer = _stylitas.styled.div`
  ${_components.feedbackMessageContainer};
  ${_components.feedbackMessage};
`;

const FeedbackMessage = ({
  className,
  variant,
  children,
  ...other
}) => {
  const Icon = variantIcon[variant];
  return (0, _core.jsx)(RootContainer, (0, _extends2.default)({
    variant: variant,
    className: className
  }, other), (0, _core.jsx)(Icon, null), children);
};

exports.FeedbackMessage = FeedbackMessage;
process.env.NODE_ENV !== "production" ? FeedbackMessage.propTypes = propTypes : void 0;
FeedbackMessage.displayName = 'FeedbackMessage';